"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomControls = void 0;
var React = _interopRequireWildcard(require("react"));
var _ControlButton = require("../ControlButton");
var _icons = require("./icons");
var styles = _interopRequireWildcard(require("./ZoomControls.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ZoomControls = _ref => {
  let {
    onZoom
  } = _ref;
  const onZoomIn = React.useCallback(() => onZoom(1.25), [onZoom]);
  const onZoomOut = React.useCallback(() => onZoom(0.75), [onZoom]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['zoom-controls']
  }, /*#__PURE__*/React.createElement(_ControlButton.ControlButton, {
    className: styles['plus-button'],
    onClick: onZoomIn
  }, /*#__PURE__*/React.createElement(_icons.PlusIcon, {
    color: "#0468ff"
  })), /*#__PURE__*/React.createElement(_ControlButton.ControlButton, {
    className: styles['minus-button'],
    onClick: onZoomOut
  }, /*#__PURE__*/React.createElement(_icons.MinusIcon, {
    color: "#0468ff"
  })));
};
exports.ZoomControls = ZoomControls;